document.addEventListener("DOMContentLoaded", function() {
  const forms = document.querySelectorAll('form');

  const validateInput = (input) => {
    // console.log('validateInput', input)
    let parent = input.parentElement;
    let errorElement = parent.nextElementSibling;

    if (!errorElement || !errorElement.classList.contains('account__error')) {
      errorElement = document.createElement('div');
      errorElement.classList.add('account__error');
      parent.parentNode.insertBefore(errorElement, parent.nextSibling);
    }

    if (input.type === 'checkbox' && input.hasAttribute('data-required')) {
      if (!input.checked) {
        input.classList.add('is-error');
        errorElement.textContent = '必須項目です。';
        errorElement.style.display = 'block';
        return false;
      } else {
        input.classList.remove('is-error');
        input.classList.remove('is-init-error');
        errorElement.textContent = '';
        errorElement.style.display = 'none';
        return true;
      }
    }

    if (input.hasAttribute('data-required') && !input.value.trim()) {
      input.classList.add('is-error');
      errorElement.textContent = '必須項目です。';
      errorElement.style.display = 'block';
      return false;
    } else if (input.hasAttribute('data-tel') && !/^(\d{3}-\d{3}-\d{4})$/.test(input.value)) {
      input.classList.add('is-error');
      errorElement.textContent = '有効な電話番号を入力してください。（例: 123-456-7890）';
      errorElement.style.display = 'block';
      return false;
    } else if (input.hasAttribute('data-email') && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(input.value)) {
      input.classList.add('is-error');
      errorElement.textContent = '有効なメールアドレスを入力してください。';
      errorElement.style.display = 'block';
      return false;
    } else if (input.hasAttribute('data-zip') && !/^\d{3}-\d{4}$/.test(input.value)) {
      input.classList.add('is-error');
      errorElement.textContent = '有効な郵便番号を入力してください。（例: 123-4567）';
      errorElement.style.display = 'block';
      return false;
    } else {
      input.classList.remove('is-error');
      input.classList.remove('is-init-error');
      errorElement.textContent = '';
      errorElement.style.display = 'none';
      return true;
    }
  }

  const initValidation = (input, submitButton) => {
    // console.log('initValidation', input)
    if (input.hasAttribute('data-required') && !input.value.trim()) {
      submitButton.disabled = true;
      input.classList.add('is-init-error');
      return false;
    } else if (input.hasAttribute('data-tel') && !/^(\d{3}-\d{3}-\d{4})$/.test(input.value)) {
      submitButton.disabled = true;
      input.classList.add('is-init-error');
      return false;
    } else if (input.hasAttribute('data-email') && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(input.value)) {
      submitButton.disabled = true;
      input.classList.add('is-init-error');
      return false;
    } else if (input.hasAttribute('data-zip') && !/^\d{3}-\d{4}$/.test(input.value)) {
      submitButton.disabled = true;
      input.classList.add('is-init-error');
      return false;
    } else {
      submitButton.disabled = true;
      input.classList.add('is-init-error');
      return true;
    }
  }

  forms.forEach(form => {
    const inputs = form.querySelectorAll('[data-validation]');
    const submitButton = form.querySelector('button[type="submit"]');

    inputs.forEach(input => {
      initValidation(input, submitButton);

      input.addEventListener('input', () => {
        // console.log('input')
        validateInput(input);
        if(form.querySelector('.is-error') || form.querySelector('.is-init-error')){
          submitButton.disabled = true;
        } else {
          submitButton.disabled = false;
        }
      });
      input.addEventListener('blur', () => {
        // console.log('blur')
        validateInput(input);
        if(form.querySelector('.is-error') || form.querySelector('.is-init-error')){
          submitButton.disabled = true;
        } else {
          submitButton.disabled = false;
        }
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      let isValid = Array.from(inputs).every(validateInput);

      if (isValid) {
        form.submit();
      } else {
        submitButton.disabled = true;
      }
    });

  });
});
